export default __webpack_public_path__ + "static/media/element_90.af3e0379.avif";